var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"max-site-width"},[_c('h1',[_vm._v("Nora Forcier 🐈")]),_c('h2',[_vm._v("Game Dev & Artist")])])
}]

export { render, staticRenderFns }